import React from 'react';

import Icon from 'components/shared/Icon/Icon';

const ResetSettingsButton = ({ onReset = () => {} }) => {
  const resetSettings = () => {
    onReset();
  };

  return (
    <div className="rounded p-2 hover:!bg-neutral-50">
      <Icon icon="rotate-ccw-mono" onClick={resetSettings} color="primary" />
    </div>
  );
};

export default ResetSettingsButton;
